<template>
	<div class="analysis-page">
		<el-card class="filter-header" shadow="never">
			<div class="filter-row">
				<div class="left-group">
					<el-date-picker v-model="filters.date" type="datetimerange" size="small" range-separator="-"
						style="width: 360px;" />
					<el-select v-model="filters.timeSlot" placeholder="默认全时段" size="small" style="width: 140px;">
						<el-option label="默认全时段" value="all" />
					</el-select>
					<el-select v-model="filters.account" placeholder="选择社媒账号" size="small" style="width: 140px;">
						<el-option label="全部账号" value="all" />
					</el-select>
					<el-select v-model="filters.member" placeholder="全部成员" size="small" style="width: 140px;">
						<el-option label="全部成员" value="all" />
					</el-select>
					<span class="refresh-time">资料更新到: 2026-01-19 15:00:37</span>
				</div>
				<el-button type="primary" size="small" icon="el-icon-share">分享</el-button>
			</div>
		</el-card>

		<el-row :gutter="20" class="stat-row">
			<el-col :span="8" v-for="(item, index) in stats" :key="index">
				<el-card shadow="never" class="stat-card">
					<div class="label">{{ item.label }} <i class="el-icon-info"></i></div>
					<div class="value" :style="{ color: item.color }">{{ item.value }}</div>
				</el-card>
			</el-col>
		</el-row>

		<el-card class="chart-box" shadow="never">
			<div slot="header" class="box-header">
				<span class="title">變化趨勢</span>
			</div>
			<trend-chart :series-data="chartSeries"
				:x-axis-data="['01-13 00:00', '01-15 00:00', '01-17 00:00', '01-19 15:00']" />
		</el-card>

		<el-card class="table-box" shadow="never">
			<div slot="header" class="table-header-tabs">
				<div class="dimension-label">添加維度：</div>
				<el-radio-group v-model="dimension" size="small">
					<el-radio-button label="接待會員" />
					<el-radio-button label="社媒渠道" />
					<el-radio-button label="社媒賬號" />
					<el-radio-button label="統計時間(小時)" />
				</el-radio-group>
				<div class="table-actions">
					<el-button size="small" icon="el-icon-download">導出</el-button>
				</div>
			</div>

			<el-table :data="tableData" border stripe style="width: 100%">
				<el-table-column prop="member" label="接待會員" />
				<el-table-column prop="group" label="分組" />
				<el-table-column prop="newCust" label="新增客戶數" sortable />
				<el-table-column prop="uniqueCust" label="新增客戶數 (去重後)" sortable />
				<el-table-column prop="repeat" label="重複數" sortable />
			</el-table>

			<div class="pagination-container">
				<el-pagination :current-page.sync="currentPage" :page-sizes="[10, 20, 50]" :total="tableData.length"
					layout="total, sizes, prev, pager, next, jumper" @size-change="fetchData"
					@current-change="fetchData" />
			</div>

		</el-card>
	</div>
</template>

<script>
import TrendChart from './components/TrendChart.vue';

export default {
	components: { TrendChart },
	data() {
		return {
			currentPage: 1,
			filters: { date: [], timeSlot: 'all', account: 'all', member: 'all' },
			dimension: '接待會員',
			stats: [
				{ label: '新增客戶數', value: 0, color: '#333' },
				{ label: '新增客戶數 (去重後)', value: 0, color: '#333' },
				{ label: '重複數', value: 0, color: '#333' }
			],
			chartSeries: [
				{ name: '新增客戶數', data: [10, 15, 4, 1], color: '#67C23A' },
				{ name: '新增客戶數 (去重後)', data: [12, 10, 1, 19], color: '#409EFF' },
				{ name: '重複數', data: [4, 10, 8, 14], color: '#F56C6C' }
			],
			tableData: [] // 初始为空，如图片所示
		};
	},
	methods: {
		fetchData() { /* 调接口 */ },
	}
};
</script>

<style lang="scss" scoped>
.analysis-page {
	background-color: #f5f7fa;
	min-height: 100vh;

	.filter-header {
		margin-bottom: 16px;

		.filter-row {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.left-group {
				display: flex;
				align-items: center;
				gap: 12px;

				.refresh-time {
					color: #999;
					font-size: 12px;
				}
			}
		}
	}

	.stat-row {
		margin-bottom: 16px;

		.stat-card {
			text-align: center;

			.label {
				color: #909399;
				font-size: 14px;
				margin-bottom: 12px;

				i {
					color: #ccc;
					cursor: pointer;
				}
			}

			.value {
				font-size: 32px;
				font-weight: bold;
			}
		}
	}

	.chart-box {
		margin-bottom: 16px;

		.box-header {
			font-weight: bold;
			font-size: 16px;
		}
	}

	.table-box {
		.table-header-tabs {
			display: flex;
			align-items: center;

			.dimension-label {
				font-size: 14px;
				color: #606266;
			}

			.table-actions {
				margin-left: auto;
			}
		}

		.pagination-container {
			margin-top: 20px;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			gap: 15px;
			color: #606266;
			font-size: 14px;
		}
	}
}

// 覆盖 Element UI 默认边框样式，更接近图片视觉
::v-deep .el-card {
	border: 1px solid #ebeef5 !important;
}
</style>